import React from "react";
import MultiLine from "../../ui/chart/MultiLine";
import MultiLine2 from "../../ui/chart/MultiLine";
import Pie from "../../ui/chart/Pie"
//import Pie2 from "../../ui/chart/Pie"

import { Button, Row, Col, DatePicker, Statistic } from "antd";
import moment from "moment";
import http from "../../../axios/http";
import "./ParkFeeSum.css";
const { RangePicker } = DatePicker;
const SLogZone = ["public", "serviceZone"];

class ParkFeeSum extends React.Component {
  state = {
    series: [],
    dates: [],
    totalData: [],
    series2: [],
    refreshChart: "",
    refreshChart2: "",
    start: "",
    end: "",
    parkZones: [],
  };

  loadAllZone = () => {
    http.post({
      url: "/barrier/parkgate/allZone",
      data: {},
      success: (res) => {
        this.setState({ parkZones: res });
      },
    });
  };

  getZoneName(zoneCode) {
    var zoneName = "";
    this.state.parkZones.forEach((row) => {
      if (row.code === zoneCode) {
        zoneName = row.name;
      }
    });
    return zoneName;
  }

  componentWillMount() {
    this.loadAllZone();
    this.setState({
      start: moment().subtract(7, "days").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
    });
    setTimeout(() => {
      this.loadData();
    }, 500);
  }

  loadData() {
    var series = [];
    var series2 = [];
    var dates = [];
    var totalData = [];
    var { start, end } = this.state;
    http.post({
      url: "/barrier/queryDayParkFeeSum",
      data: { start, end },
      success: (res) => {
        var dics = {};
        var days = {};
        var tdata = {};
        res.forEach((item) => {
          var temp = item.type.split("_");
          var type = temp[0];
          var date = item.date;
          var zone = "";
          if (temp.length > 1) {
            zone = temp[1];
          }
          var name = this.getTypeName(type, zone);
          if (name) {
            days[date] = date;
            if (!dics[name]) {
              dics[name] = {};
            }
            if (!tdata[name]) {
              tdata[name] = item.value;
            } else {
              tdata[name] += item.value;
            }
            dics[name][date] = (dics[name][date] || 0) + item.value;
          }
        });
        for (var d in days) {
          dates.push(d);
        }
        dates.sort();
        for (var k in dics) {
          var newSerie = {
            text: k,
            data: [],
            area: k === "停车费收入" ? {} : null,
          };
          FillDateData(newSerie, dics, k);
          if (k === "停车费收入") series.push(newSerie);
          else series2.push(newSerie);
        }
        for (var t in tdata) {
          totalData.push({
            name: t,
            value: tdata[t],
          });
        }
        totalData.sort((a, b) => {
          if (a.name > b.name) return 1;
          else if (a.name < b.name) return -1;
          else return 0;
        });
        console.log("dates", dates);
        console.log("series", series);
        console.log("totalData", totalData);
        this.setState({ dates, series, series2, totalData });
        //this.state.refreshChart();
        //this.state.refreshChart2();
      },
    });

    http.post({
      url: "/barrier/getParkDurationStatistics",
      data: { start, end },
      success: (res) => {
        let pieData=[
          {
            value: res.lessThanOne,
            name: '1小时内'
          },
          {
            value: res.oneAndTwo,
            name: '1-2小时'
          },
          {
            value: res.twoAndThree,
            name: '2-3小时'
          }
          ,{
            value: res.greaterThanThree,
            name: '3小时以上'
          }
        ]
        this.setState({pieData});
      }
    })

    function FillDateData(newSerie, dics, k) {
      dates.forEach((d) => {
        newSerie.data.push(dics[k][d] || 0);
      });
    }
    //todo
    // let pieData2=[
    //   {
    //     value: 20832,
    //     name: '1小时内'
    //   },
    //   {
    //     value: 2786,
    //     name: '1-2小时'
    //   },
    //   {
    //     value: 861,
    //     name: '2-3小时'
    //   }
    //   ,{
    //     value: 1025,
    //     name: '3小时以上'
    //   }
    // ]

    //,pieData2



  }

  getTypeName(type, zone) {
    switch (type) {
      case "ParkFeeSum":
        return "停车费收入";
      case "SLogCount":
        if (~SLogZone.indexOf(zone)) return "车流量-" + this.getZoneName(zone);
        return "";
      case "BLogCount":
        return "扫码通行量-" + this.getZoneName(zone);
      default:
        return "";
    }
  }

  periodChange = (val, valstr) => {
    console.log("periodChange", valstr);
    this.setState({ start: valstr[0], end: valstr[1] });
    this.loadData();
    setTimeout(() => {
      this.loadData();
    }, 500);
  };

  render() {
    var dateFormat = "YYYY-MM-DD";
    var { series, series2, dates, start, end, totalData,pieData } = this.state; //
    console.log(series);
    return (
      <div style={{ width: "100%", height: "100%", overflow: "auto" }}>
        <Row>
          <Col span={24} style={{ textAlign: "left" }}>
            <RangePicker
              defaultValue={[moment(start), moment(end)]}
              onChange={this.periodChange}
              ranges={{
                昨天: [moment().subtract(1, "days"), moment()],
                本周: [moment().startOf("week"), moment().endOf("week")],
                上周: [
                  moment()
                    .week(moment().week() - 1)
                    .startOf("week"),
                  moment()
                    .week(moment().week() - 1)
                    .endOf("week"),
                ],
                本月: [moment().startOf("month"), moment().endOf("month")],
              }}
              format={dateFormat}
              allowClear={false}
            />{" "}
            &nbsp;
            <Button type="primary" onClick={this.loadData.bind(this)}>
              查询
            </Button>
          </Col>
        </Row>
        <div className="sum-head" key="hede">
          <Row>
            {totalData.map((item) => (
              <Col span={4} key={item.name} className="head-statistic">
                <Statistic
                  title={item.name}
                  value={item.value}
                  suffix={item.name === "停车费收入" ? "元" : ""}
                />
              </Col>
            ))}
          </Row>
        </div>
        <Row>
          <Col span={24}>
            <MultiLine
              key="parkFee"
              title="停车费统计"
              data={series}
              xData={dates}
              yNames={["停车费(元)"]}
              height="400px"
              refreshChart={(func) => {
                this.setState({ refreshChart: func });
              }}
            ></MultiLine>
          </Col>
        </Row>
            
        <Row>
          <Col span={24} style={{height: 400}}>
            <Pie 
              key="stayTime"
              title="停车时长分布"
              legendShow={false}
              data={pieData}
              labelShow={true}
              subtext='不含白名单、停车券、无牌车及交易车'
              refreshChart={(func) => {
                this.setState({ refreshPie: func });
              }}
            ></Pie>
          </Col>
          {/* <Col span={12} style={{height: 400}}>
            <Pie2 
              key="outType"
              title="出场方式分布"
              legendShow={false}
              data={pieData2}
              refreshChart={(func) => {
                this.setState({ refreshPie2: func });
              }}
            ></Pie2>
          </Col> */}
        </Row>
        <Row>
          <Col span={24}>
            <MultiLine2
              key="carCount"
              title="车流量统计"
              data={series2}
              xData={dates}
              yNames={["车流量"]}
              height="400px"
              refreshChart={(func) => {
                this.setState({ refreshChart2: func });
              }}
            ></MultiLine2>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ParkFeeSum;
